import React from 'react'
import CreatePerson from '../People/CreatePerson'

const CreateTeacher = () => <CreatePerson kind="teacher" />

export default CreateTeacher
